import { httpClient2 } from 'src/infrastructure/admi-client/http-client';
import { Company } from './crm.dto';

export const admiCompanyService = {
    async searchCompanies(filter: string): Promise<Company[]> {
        const response = await httpClient2.get<Company[]>('/v1/crm/companies/search', { params: { filter } });

        return response.data;
    },
};
